import { faFacebookF, faInstagram, faLinkedinIn, faXTwitter } from "@fortawesome/free-brands-svg-icons";
import { faArrowRight, faLink } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiRequest from "../helper/ApiRequest";
import { BaseUrl } from "../helper/BaseUrl";
import Breadcrumb from "../../component/Breadcrumb";

const formatDate = (isoDate) => {
  if (!isoDate) return "";
  const date = new Date(isoDate);
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();

  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  const month = monthNames[date.getMonth()];

  return `${month} ${day}, ${year}`;
};

export default function AIBlogContent({ data }) {

  const [payload, setPayload] = useState({
    email: "",
  });
  const [activeId, setActiveId] = useState(null);

  const navigate = useNavigate();

  const currentUrl = window.location.href;
  const copyToClipboard = () => {
    navigator.clipboard.writeText(currentUrl);
    toast.success("Link copied to clipboard!", {
      autoClose: 800,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await ApiRequest("POST", "api/newsletter/store", payload,);
      toast.success(response.message);
      navigate("/thankyou")
    } catch (error) {
      console.error(error);
    }
  };

  const handleScroll = (id) => {
    setActiveId(id);
    const element = document.getElementById(id);
    if (element) {
      const yOffset = -100; // 👈 offset from top (90px)
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({
        top: y,
        behavior: "smooth",
      });
    }
  };

  const sectionIds = [
    "heading2",
    "heading3",
    "heading4",
    "heading5",
    "heading6",
    "heading7",
    "heading8",
    "heading9",
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveId(entry.target.id);
          }
        });
      },
      {
        root: null,
        rootMargin: "-20% 0px -80% 0px",
        threshold: 0,
      }
    );

    sectionIds.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [sectionIds]);

  const breadcrumbData = {
    newClass: "",
    list: [
      {
        page: "Home",
        slug: "/"
      },
      {
        page: "blogs",
        slug: "/blog"
      },
      {
        page: data?.name?.slice(0, 12) + "...",
        slug: `/ai-blog/${data?.slug}`
      },
    ]
  }

  if(!data?.heading2) {return (<div style={{width:"100%", height:"150vh", backgroundColor:"#fff"}}></div>)};
  return (
    <>
      <section className="ai-blog-details header-gap">
        <div className="container">
          <div className="row">

            <div className="col-lg-12">
              <div className="ai-blog-header">
                <Breadcrumb breadcrumbData={breadcrumbData}/>
                <div className="ai-blog-type">
                  <small>{formatDate(data?.createdAt)}</small>
                  <small>{data?.category_name}</small>
                </div>
                <div className="ai-blog-title-container">
                  <h1 className="heading">{data?.name}</h1>
                  <div className="ai-blog-userbox">
                    <div className="ai-blog-author">
                      <img src={`${BaseUrl}${data?.author_image}`} alt="user" className="img-responsive" />
                      <div>
                        <label>{data?.author_name}</label>
                        <small>{data?.author_designation}</small>
                      </div>
                    </div>
                    <p>Updated on {formatDate(data?.createdAt)}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="ai-blog-container">
                <div className="row">

                  <div className="col-lg-3 col-md-4">
                    <div className="ai-blog-indexing">
                      <span>Content</span>
                      <ul>
                        <li className={activeId === "heading2" ? "active" : ""}><a onClick={() => handleScroll("heading2")}>{data?.heading1}</a></li>
                        <li className={activeId === "heading3" ? "active" : ""}><a onClick={() => handleScroll("heading3")}>{data?.heading2}</a></li>
                        {data?.heading3 && <li className={activeId === "heading4" ? "active" : ""}><a onClick={() => handleScroll("heading4")}>{data?.heading3}</a></li>}
                        {data?.heading4 && <li className={activeId === "heading5" ? "active" : ""}><a onClick={() => handleScroll("heading5")}>{data?.heading4}</a></li>}
                        {data?.heading5 && <li className={activeId === "heading6" ? "active" : ""}><a onClick={() => handleScroll("heading6")}>{data?.heading5}</a></li>}
                        {data?.heading6 && <li className={activeId === "heading7" ? "active" : ""}><a onClick={() => handleScroll("heading7")}>{data?.heading6}</a></li>}
                        {data?.heading7 && <li className={activeId === "heading8" ? "active" : ""}><a onClick={() => handleScroll("heading8")}>{data?.heading7}</a></li>}
                        <li className={activeId === "heading9" ? "active" : ""}><a onClick={() => handleScroll("heading9")}>{data?.conclusion}</a></li>
                      </ul>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-8">
                    <div className="ai-blog-content">
                      <div dangerouslySetInnerHTML={{ __html: data?.description }} />

                      <h2 id="heading2" className="heading">{data?.heading1}</h2>

                      <div dangerouslySetInnerHTML={{ __html: data?.description1 }} />

                      <img src={`${BaseUrl}${data?.image1}`} alt={data?.alt_image1 || "ai blogs"} className="img-responsive" />

                      <h2 id="heading3" className="heading">{data?.heading2}</h2>

                      <div dangerouslySetInnerHTML={{ __html: data?.description2 }} />

                      <img src={`${BaseUrl}${data?.image2}`} alt={data?.alt_image2 || "ai blogs"} className="img-responsive" />

                      {data?.heading3 && (
                        <>
                          <h2 id="heading4" className="heading">{data.heading3}</h2>

                          <div dangerouslySetInnerHTML={{ __html: data?.description3 }} />

                          <img src={`${BaseUrl}${data?.image3}`} alt={data?.alt_image3 || "ai blogs"} className="img-responsive" />
                        </>
                      )}

                      {data?.heading4 && (
                        <>
                          <h2 id="heading5" className="heading">{data.heading4}</h2>

                          <div dangerouslySetInnerHTML={{ __html: data?.description4 }} />

                          <img src={`${BaseUrl}${data?.image4}`} alt={data?.alt_image4 || "ai blogs"} className="img-responsive" />
                        </>
                      )}

                      {data?.heading5 && (
                        <>
                          <h2 id="heading6" className="heading">{data.heading5}</h2>

                          <div dangerouslySetInnerHTML={{ __html: data?.description5 }} />

                          <img src={`${BaseUrl}${data?.image5}`} alt={data?.alt_image5 || "ai blogs"} className="img-responsive" />
                        </>
                      )}

                      {data?.heading6 && (
                        <>
                          <h2 id="heading7" className="heading">{data.heading6}</h2>

                          <div dangerouslySetInnerHTML={{ __html: data?.description6 }} />

                          <img src={`${BaseUrl}${data?.image6}`} alt={data?.alt_image6 || "ai blogs"} className="img-responsive" />
                        </>
                      )}

                      {data?.heading7 && (
                        <>
                          <h2 id="heading8" className="heading">{data.heading7}</h2>

                          <div dangerouslySetInnerHTML={{ __html: data?.description7 }} />

                          <img src={`${BaseUrl}${data?.image7}`} alt={data?.alt_image7 || "ai blogs"} className="img-responsive" />
                        </>
                      )}

                      <h2 id="heading9" className="heading">{data?.conclusion}</h2>
                      <div dangerouslySetInnerHTML={{ __html: data?.conclusion_description }} />

                      <div className="blog-uptodate">
                        <span>Stay up to date</span>
                        <p>Join 6,000+ marketers and subscribe to our weekly newsletter for exclusive social media news, tips and insights you need to boost results.</p>
                        <form onSubmit={handleSubmit}>
                          <input type="email" placeholder="Enter Email Address" required onChange={(e) => setPayload((prev) => ({ ...prev, email: e.target.value }))} />
                          <button type="submit"><FontAwesomeIcon icon={faArrowRight} /></button>
                        </form>
                      </div>

                      <div className="ai-user-info">
                        <img src={`${BaseUrl}${data?.author_image}`} alt="user" className="img-responsive" />
                        <div className="ai-user-detail">
                          <div className="ai-user-logos">
                            <small>Written by</small>
                            <div>
                              {data?.author_linkedin && <span><a href={data?.author_linkedin} target="_blank"><FontAwesomeIcon icon={faLinkedinIn} /></a></span>}
                              {data?.author_facebook && <span><a href={data?.author_facebook} target="_blank"><FontAwesomeIcon icon={faFacebookF} /></a></span>}
                              {data?.author_instagram && <span><a href={data?.author_instagram} target="_blank"><FontAwesomeIcon icon={faInstagram} /></a></span>}
                            </div>
                          </div>
                          <h4>{data?.author_name}</h4>
                          <p>{data?.author_description}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3">
                    <div className="ai-blog-newsletter-wrapper">
                      <div className="ai-blog-newsletter">
                        <h3>Receive insights before anyone else</h3>
                        <p>Sign up to receive our weekly social & digital newsletter read by 12,500+ CMOs & Marketing Managers</p>
                        <form onSubmit={handleSubmit}>
                          <input type="email" placeholder="Enter Email Address" required onChange={(e) => setPayload((prev) => ({ ...prev, email: e.target.value }))} />
                          <button type="submit"><FontAwesomeIcon icon={faArrowRight} /></button>
                        </form>
                      </div>

                      <div className="ai-blog-share">
                        <label>Share:</label>
                        <ul>
                          <li><a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faInstagram} /></a></li>
                          <li><a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`} target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faFacebookF} /></a></li>
                          <li><a href={`https://twitter.com/share?url=${encodeURIComponent(currentUrl)}&text=Check this out!`} target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faXTwitter} /></a></li>
                          <li><a href="#" onClick={(e) => { e.preventDefault(); copyToClipboard(); }}><FontAwesomeIcon icon={faLink} /></a></li>
                        </ul>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
